'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import {
  Xf,
  ProductionArtifact,
  ProductionIllustrativeBadge,
} from './production-primitives';
import { FileTypeIcon } from './deliverable-files';
import { ef, J } from './sell-market-animation';
import { ProductionIcon } from './deliverable-previews';
import { ShowcaseIcon } from './scene-primitives';
import { referenceProducts, ue } from './reference-products';
export const Zf = 300;
export const Qf = 520;
export const $f = Zf + Xf.length * Qf + 200;
export const ep = [
  {
    x: -6,
    y: 10,
    r: -5,
  },
  {
    x: 8,
    y: 6,
    r: 4,
  },
  {
    x: -4,
    y: 2,
    r: -2,
  },
  {
    x: 6,
    y: -2,
    r: 3,
  },
  {
    x: -2,
    y: -6,
    r: -1,
  },
  {
    x: 0,
    y: -10,
    r: 0,
  },
];
export function ProductionFolderItem({ doc: e, index: t, t: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let r = ep[t] ?? {
    x: 0,
    y: 0,
    r: 0,
  };
  return (
    <div
      data-on={String(n >= Zf + t * Qf)}
      className={
        'pd-drop absolute inset-x-0 top-[9%] mx-auto w-[58%] max-w-[188px]'
      }
      style={{
        zIndex: t + 1,
      }}
    >
      <div
        className={'pop flex aspect-[3/3.5] flex-col gap-2 rounded-[10px] p-3'}
        style={{
          transform: `translate(${r.x}px, ${r.y}px) rotate(${r.r}deg)`,
        }}
      >
        <div className={'flex items-center gap-2'}>
          <FileTypeIcon kind={e.kind} className={'h-7 w-6'} />
          <span className={'min-w-0 flex-1'}>
            <span className={'text-ink block truncate text-[12px] font-medium'}>
              {translateShowcaseNode(showcaseCopy, e.what)}
            </span>
            <span
              className={'text-ink-4 block truncate font-mono text-[10.5px]'}
            >
              {translateShowcaseNode(showcaseCopy, e.name)}
            </span>
          </span>
        </div>
        <div aria-hidden={!0} className={'flex flex-col gap-1.5 pt-1'}>
          {translateShowcaseNode(
            showcaseCopy,
            [92, 78, 86, 64, 80, 52].map((e, t) => (
              <span
                key={t}
                className={'block h-[3px] rounded-full bg-[var(--tint-2)]'}
                style={{
                  width: `${e}%`,
                }}
              />
            ))
          )}
        </div>
        <span className={'text-ink-4 num mt-auto font-mono text-[10.5px]'}>
          {translateShowcaseNode(showcaseCopy, e.version)}
        </span>
      </div>
    </div>
  );
}
export function FactoryHandoff({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = ef(e, 500, Qf, Xf.length);
  return (
    <ProductionArtifact
      icon={'layers'}
      title={translateShowcaseNode(showcaseCopy, 'Factory Handoff')}
      view={'Folder'}
      footer={
        <React.Fragment>
          <span
            {...J(e, $f)}
            className={
              'pd-in text-ink flex min-w-0 items-center gap-2 text-[13px]'
            }
          >
            <ProductionIcon
              name={'package'}
              className={'text-ink-3 size-4 shrink-0'}
            />
            <span className={'truncate'}>
              {translateShowcaseNode(
                showcaseCopy,
                'Ready for your review, then you send it.'
              )}
            </span>
          </span>
          <span
            {...J(e, $f)}
            aria-hidden={!0}
            className={'pd-pop btn btn-ink btn-sm ml-auto shrink-0'}
          >
            {translateShowcaseNode(showcaseCopy, 'Review packet')}
          </span>
        </React.Fragment>
      }
    >
      <div
        className={
          'grid gap-4 p-3 sm:p-5 md:grid-cols-[minmax(0,0.85fr)_minmax(0,1fr)] md:gap-6'
        }
      >
        <div
          aria-hidden={!0}
          className={
            'relative h-[260px] overflow-hidden rounded-[12px] bg-[var(--tint)] md:h-auto md:min-h-[330px]'
          }
        >
          {translateShowcaseNode(
            showcaseCopy,
            Xf.map((t, n) => (
              <ProductionFolderItem key={t.name} doc={t} index={n} t={e} />
            ))
          )}
          <span
            {...J(e, $f)}
            className={
              'pd-pop absolute bottom-3 left-1/2 z-10 flex h-7 -translate-x-1/2 items-center gap-1.5 rounded-full bg-[var(--panel)] px-2.5 font-mono text-[11.5px] whitespace-nowrap shadow-[var(--shadow-minimal)]'
            }
          >
            <FileTypeIcon kind={'file'} className={'h-4 w-3.5'} detail={!1} />
            <span className={'text-ink-2'}>
              {translateShowcaseNode(showcaseCopy, 'cor-tote-01-handoff.zip')}
            </span>
          </span>
        </div>
        <div className={'flex min-w-0 flex-col'}>
          <div className={'flex items-center gap-2'}>
            <p className={'label'}>
              {translateShowcaseNode(showcaseCopy, 'Latest approved versions')}
            </p>
            <ProductionIllustrativeBadge className={'ml-auto'} />
          </div>
          <div
            className={
              'text-ink-4 mt-2 grid grid-cols-[minmax(0,1fr)_auto_auto] gap-x-3 border-b border-[var(--line)] pb-1.5 text-[12px] font-medium'
            }
          >
            <span>{translateShowcaseNode(showcaseCopy, 'Name')}</span>
            <span className={'max-sm:hidden'}>
              {translateShowcaseNode(showcaseCopy, 'Size')}
            </span>
            <span>{translateShowcaseNode(showcaseCopy, 'Version')}</span>
          </div>
          <ul className={'flex flex-col'}>
            {translateShowcaseNode(
              showcaseCopy,
              Xf.map((e, n) => (
                <li
                  key={e.name}
                  data-on={String(t > n)}
                  className={
                    'pd-in grid h-10 grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-x-3 border-b border-[var(--line)] text-[12.5px] last:border-0'
                  }
                >
                  <span className={'flex min-w-0 items-center gap-2'}>
                    <FileTypeIcon
                      kind={e.kind}
                      className={'h-[22px] w-5'}
                      detail={!1}
                    />
                    <span className={'text-ink-2 truncate font-mono'}>
                      {translateShowcaseNode(showcaseCopy, e.name)}
                    </span>
                  </span>
                  <span className={'num text-ink-4 max-sm:hidden'}>
                    {translateShowcaseNode(showcaseCopy, e.size)}
                  </span>
                  <span className={'flex items-center gap-1.5'}>
                    <span className={'num text-ink-3 font-mono'}>
                      {translateShowcaseNode(showcaseCopy, e.version)}
                    </span>
                    <ShowcaseIcon
                      name={'check'}
                      className={'size-3.5 text-[var(--pd-green)]'}
                      strokeWidth={2}
                    />
                  </span>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </ProductionArtifact>
  );
}
export const rp = ['v4', 'v3', 'v5', 'v3', 'v4', 'v2'];
export const ip = (e) => referenceProducts.filter((t) => t.role === e);
export const ap = ip('Core').filter((e) => e.category === 'Knitwear');
export const op = ap[ap.length - 1];
export const sp = ap[0];
export const cp = ip('Entry')[0];
export const lp = referenceProducts.find((e) => e.colorway === 'Oxblood');
export const up = [
  `Direction confirmed: ${ue.name}.`,
  op && sp
    ? `${op.style} stays in delivery 1; the ${sp.style} moves to delivery 2.`
    : 'Core knits split across two deliveries.',
  cp
    ? `${cp.style} stays the entry piece at ${((e) => `$${e.toLocaleString('en-US')}`)(cp.price)}.`
    : 'Entry piece confirmed.',
];
export const dp = [
  'Add one entry piece in tailoring before the buyer package.',
  lp
    ? `${lp.style} in ${lp.colorway}: lab dip approval pending.`
    : 'Accent colour lab dip approval pending.',
];
export const fp = 4300;
export function LockIllustration({ t: e }) {
  let t = e >= 3800,
    n = e >= fp;
  return (
    <svg
      viewBox={'0 0 40 40'}
      fill={'none'}
      stroke={'currentColor'}
      strokeWidth={'1.5'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
      aria-hidden={!0}
      className={'text-ink size-10'}
    >
      <rect
        x={'9'}
        y={'18'}
        width={'22'}
        height={'16'}
        rx={'4'}
        pathLength={1}
        className={'pd-line'}
        data-on={String(t)}
      />
      <path
        d={'M14 18v-4.5a6 6 0 0 1 12 0V18'}
        pathLength={1}
        className={'pd-line'}
        data-on={String(t)}
        style={{
          transform: n ? 'none' : 'translateY(-4px)',
          transition:
            'stroke-dashoffset 900ms var(--ease), opacity 120ms linear, transform 260ms var(--ease)',
        }}
      />
      <path
        d={'M20 24.5v3'}
        pathLength={1}
        className={'pd-line pd-line-fast'}
        data-on={String(n)}
      />
    </svg>
  );
}
export function FreezeDecision({
  title: e,
  count: t,
  t: n,
  start: r,
  children: i,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <section {...J(n, r)} className={'pd-in flex flex-col gap-2'}>
      <h4 className={'flex items-center gap-2 text-[13px]'}>
        <span className={'text-ink font-semibold'}>
          {translateShowcaseNode(showcaseCopy, e)}
        </span>
        <span className={'num text-ink-4'}>
          {translateShowcaseNode(showcaseCopy, t)}
        </span>
      </h4>
      {translateShowcaseNode(showcaseCopy, i)}
    </section>
  );
}
